import { useToast } from '@chakra-ui/react';

export const CustomToast = () => {
  const toast = useToast();
  // types are: "success", "info", "warning", "error"

  const addToast = (newRes, type, position = 'top-right', duration = 5000) => {
    toast({
      description: newRes.message ?? newRes,
      status: newRes.type || type || 'success',
      position: position,
      isClosable: true,
      duration: newRes.duration || duration,
      variant: 'left-accent',
    });
  };

  return { addToast };
};
